<template>
  <div class="screen">
    <div class="top">
      <div @click="onBack" class="back">
        <i class="el-icon-back"></i> 返回
      </div>
      <div v-if="monitorData" class="info">
        {{monitorData && monitorData.teacherName ? monitorData.teacherName : monitorData.monitorCode}}，你好，欢迎查看考评统计
      </div>
      <div class="setting">
        <SettingTab @onChangeLoop="onChangeLoop"></SettingTab>
      </div>
      <div @click="onLogout" class="logout">
        退出登录
      </div>
    </div>
    <div class="content">
      <DataRange :searchData="searchData" @onSelectDataRange="onSelectDataRange" class="mb-20"></DataRange>
      <div class="content-view custom-scrollbar">
        <template v-if="showCityStatistic">
          <ContentView width="100%" height="50%" flex="flex-start" :border="false">
            <ContentView title="专业考试进度" width="34%">
              <BarChart :chartData="chartDataMap.specialityStatMap"></BarChart>
            </ContentView>
            <ContentView title="整体考试进度" :border="false" width="26%" class="ml-15 mr-15">
              <div v-if="chartDataMap.statisticStatMap && chartDataMap.statisticStatMap.totalNum >= 0" class="process">
                <el-progress type="circle" :width="260" :stroke-width="30" :percentage="foramtPercent(chartDataMap.statisticStatMap.gradedNum,chartDataMap.statisticStatMap.totalNum)" :show-text="false" text-color="#fff" color="#06fcffdf" define-back-color="#283d5a">
                  <!--  stroke-linecap="square" -->
                </el-progress>
                <div class="inner-text process-text txt-c">
                  <div class="font-36">{{chartDataMap.statisticStatMap.gradedNum | calcPercent(chartDataMap.statisticStatMap.totalNum)}}</div>
                  <div class="font-16">{{chartDataMap.statisticStatMap.gradedNum}}/{{chartDataMap.statisticStatMap.totalNum}}</div>
                </div>
                <div class="process-text mt-10">已考试考生/总考生</div>
              </div>
            </ContentView>
            <ContentView title="地市考试进度" width="40%">
              <BarChart :chartData="chartDataMap.cityStatMap" direction="Y"></BarChart>
            </ContentView>
          </ContentView>
          <ContentView width="100%" height="50%" flex="flex-start" :border="false">
            <ContentView title="考场考试进度" width="34%">
              <BarChart :chartData="chartDataMap.roomStatMap" direction="Y"></BarChart>
            </ContentView>
            <ContentView title="地市考试进度详情" width="66%" class="ml-15">
              <DataTable :tableData="chartDataMap.cityStatTable"></DataTable>
            </ContentView>
          </ContentView>
        </template>
        <template v-else>
          <ContentView width="100%" height="60%" flex="flex-start" :border="false">
            <ContentView title="专业考试进度" width="34%">
              <BarChart :chartData="chartDataMap.specialityStatMap"></BarChart>
            </ContentView>
            <ContentView title="整体考试进度" :border="false" width="26%" class="ml-15 mr-15">
              <div v-if="chartDataMap.statisticStatMap && chartDataMap.statisticStatMap.totalNum >= 0" class="process">
                <el-progress type="circle" :width="260" :stroke-width="30" :percentage="foramtPercent(chartDataMap.statisticStatMap.gradedNum,chartDataMap.statisticStatMap.totalNum)" :show-text="false" text-color="#fff" color="#06fcffdf" define-back-color="#283d5a">
                  <!--  stroke-linecap="square" -->
                </el-progress>
                <div class="inner-text process-text txt-c">
                  <div class="font-36">{{chartDataMap.statisticStatMap.gradedNum | calcPercent(chartDataMap.statisticStatMap.totalNum)}}</div>
                  <div class="font-16">{{chartDataMap.statisticStatMap.gradedNum}}/{{chartDataMap.statisticStatMap.totalNum}}</div>
                </div>
                <div class="process-text mt-10">已考试考生/总考生</div>
              </div>
            </ContentView>
            <ContentView title="考场考试进度" width="40%">
              <BarChart :chartData="chartDataMap.roomStatMap" direction="Y"></BarChart>
            </ContentView>
          </ContentView>
        </template>
      </div>
    </div>
    <SelectData :visible.sync="visible" @getStatisticId="getStatisticId" @getDataRange="getDataRange"></SelectData>
  </div>
</template>

<script>
import SettingTab from './components/setting-tab.vue';
import SelectData from '../components/select-data.vue';
import DataRange from './components/data-range.vue';
import BarChart from './components/bar-chart.vue';
import ContentView from './components/content-view.vue';
import DataTable from './components/data-table.vue';
import ApiDataView from '@/apis/api-data-view.js';
export default {
  name: 'data-view',
  components: {SettingTab, SelectData, DataRange, BarChart, ContentView, DataTable},
  data() {
    return {
      visible: false,
      monitorData: null,
      roomData: null,
      chartDataMap: {
        cityStatTable: [],
        cityStatMap: {},
        roomStatMap: {},
        specialityStatMap: {},
        statisticStatMap: {},
      },
      // 轮训定时器
      loopTimer: null,
      // 多少秒走一次轮训
      loopStep: 1,
      // 当前考评统计的数据ID
      statisticId: '',
      searchData: null,
      showCityStatistic: false
    }
  },
  created() {
    this.monitorData = this._storage.getStorageSync('monitorData')
    this.roomData = this._storage.getStorageSync('roomData')
    this.statisticId = this._storage.getStorageSync('statisticId')
    this.searchData = this._storage.getStorageSync('dataRange')
    this.showCityStatistic = this._storage.getStorageSync('userInfo').showCityStatistic || false
    this.getData()
  },
  methods: {
    onChangeLoop(val) {
      this.loopStep = val
      this.onCleartimer()
      if (val === 1) {
        this.getData()
      } else {
        this.onInitData()
      }
      this.$message.success('设置成功！')
    },
    async onInitData() {
      await this.getData()
      this.onStartTimer()
    },
    async onStartTimer() {
      const _this = this
      this.onCleartimer()
      this.loopTimer = setInterval(() => {
        this.getData()
      }, this.loopStep * 1000);
      this.$once("hook:beforeDestroy", () => {
        // 销毁页面后取消订阅，避免多次订阅
        _this.onCleartimer()
      });
      this.$once("hook:destroyed", () => {
        // 销毁页面后取消订阅，避免多次订阅
        _this.onCleartimer()
      });
    },
    onCleartimer() {
      if (this.loopTimer) {
        clearInterval(this.loopTimer)
        this.loopTimer = null
      }
    },
    getDataRange(val) {
      this.searchData = val
    },
    getStatisticId(val) {
      this.statisticId = val
      if (this.loopStep) {
        this.onChangeLoop(this.loopStep)
      }
    },
    async getData() {
      const res = await ApiDataView.GETstatisticDetail({statisticId: this.statisticId})
      if (res) {
        this.chartDataMap.cityStatTable = res.cityStat || []
        this.chartDataMap.cityStatMap = this.formatChartData(res.cityStat)
        this.chartDataMap.roomStatMap = this.formatChartData(res.roomStat)
        this.chartDataMap.specialityStatMap = this.formatChartData(res.specialityStat)
        this.chartDataMap.statisticStatMap = res.statisticStat || []
      }
    },
    formatChartData(res) {
      const result = {
        columns: [],
        columnValues: [],
        dataMap: [],
        source: []
      }
      if (res) {
        res.forEach(v => {
          const percent = this.foramtPercent(v.gradedNum, v.totalNum) || 0
          result.dataMap.push({
            percent,
            title: `${v.gradedNum}/${v.totalNum}`
          })
          result.columns.push(v.roundName)
          result.columnValues.push(percent)
        })
        result.source = res
      }
      return result
    },
    // 计算百分比
    foramtPercent(val, data) {
      let a = val
      let b = data
      if (val < 0) {
        a = 0
      }
      if (data < 0) {
        b = 0
      }
      const result = val >= data ? 100 : `${((a * 100) / b).toFixed(2)}`
      return Number(result)
    },
    onSelectDataRange() {
      this.visible = true
    },
    onLogout() {
      this.$confirm('是否确认退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this._storage.removeStorageSync('collegeId')
        this._storage.removeStorageSync('userInfo')
        this._storage.removeStorageSync('monitorData')
        this.$router.replace('/')
      }).catch(() => {

      });
    },
    onBack() {
      this.$router.back()
    },
  }
}
</script>

<style lang="scss" scoped>
.screen {
  width: 100%;
  height: 100%;
}
.top {
  color: #fff;
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  // background: rgba($color: #04070F, $alpha: 0.32);
  background: #2e2c8a;

  .info {
    margin-left: 20px;
  }
  .setting {
    flex: 1;
  }
  .logout {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    cursor: pointer;
    width: 120px;
    height: 32px;
    border: 1px solid #FFFFFF;
    border-radius: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: #FFFFFF;
  }
  .back {
    cursor: pointer;
    border: 1px solid #FFFFFF;
    border-radius: 16px;
    font-size: 14px;
    padding: 5px 15px;
  }
}
.content {
  position: relative;
  width: 100%;
  height: calc(100% - 60px);
  background: #0a084d;
  padding: 20px;
}
.process {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
}
.inner-text {
  position: absolute;
  left: 50%;
  top: calc(50% - 10px);
  transform: translate(-50%, -50%);
}
.process-text {
  color: #17C6EA;
  font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold', 'PingFang SC', sans-serif;
  font-weight: 650;
}
.content-view {
  width: 100%;
  height: calc(100% - 46px - 15px);
  overflow-y: auto;
}
</style>
